import { Controller } from "@hotwired/stimulus"

// Replaces the table row with a spinner while a nested form is submitting.
export default class extends Controller {
  static values = { columns: Number }

  connect () {
    this.form = this.element.querySelector("form")
    if (!this.form) return

    this.onSubmitStart = this.showSpinner.bind(this)
    this.form.addEventListener("turbo:submit-start", this.onSubmitStart)
  }

  disconnect () {
    this.form?.removeEventListener("turbo:submit-start", this.onSubmitStart)
  }

  showSpinner () {
    const columns = this.columnsValue || this.element.children.length
    this.element.innerHTML = `<td class="tablev2__cell text-center" colspan="${columns}"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></td>`
  }
}
